import Layout from "@/layout"
export default [
  {
    path: "/system",
    component: Layout,
    redirect: "/system/user-manage",
    meta: {
      title: "系统管理",
      icon: "system-manage"
    },
    children: [
      {
        path: "/system/config-manage",
        name: "systemConfigManage",
        component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/config-manage/index.vue"),
        meta: {
          title: "配置管理", //meta里面也要有title 用于面包屑上使用
          cache: "1",
          showFooter: true // 展示页脚
        }
      },
      {
        path: "/system/user-manage",
        name: "systemUserManage",
        component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/user-manage/index.vue"),
        meta: {
          title: "用户管理", //meta里面也要有title 用于面包屑上使用
          cache: "1",
          showFooter: true // 展示页脚
        }
      },
      {
        path: "/system/role-manage",
        name: "systemRoleManage",
        component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/role-manage/index.vue"),
        meta: {
          title: "角色管理", //meta里面也要有title 用于面包屑上使用
          icon: "role-manage",
          cache: "1"
        }
      },
      {
        path: "/system/dict-manage",
        name: "systemDictManage",
        component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/dict-manage/index.vue"),
        meta: {
          title: "字典管理", //meta里面也要有title 用于面包屑上使用
          icon: "dict-manage",
          cache: "1"
        }
      },    
      {
        path: "/system/dict-item-manage",
        name: "systemDictItemManage",
        hidden: true,
        component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/dict-item-manage/index.vue"),
        meta: {
          activeMenuPath: "/system/dict-manage",
          cache: "0", // 不缓存
          title: "字典项管理" //meta里面也要有title 用于面包屑上使用
        }
      }, 
      {
        path: "/system/menu-manage",
        name: "systemMenuManage",
        component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/menu-manage"),
        meta: {
          title: "菜单管理", //meta里面也要有title 用于面包屑上使用
          icon: "menu-manage"
        }
      },
      {
        path: "/system/user-detail",
        name: "systemUserDetail",
        component: () => import(/* webpackChunkName: "systemModule" */"@/views/system/user-manage/detail.vue"),
        meta: {
          activeMenuPath: "/system/user-manage",
          title: "用户详情", //meta里面也要有title 用于面包屑上使用
          showFooter: true // 展示页脚
        },
        hidden: true
      }
    ]
  }
]